import React, { createContext, useContext } from "react";
import { ToastContainer } from "react-toastify";
import axios from "axios";

import MailkickSubscriptionIndex from "./MailkickSubscriptionIndex";

const MailkickSubscriptionIndexContext = createContext();

export function useMailkickSubscriptionIndexContext() {
  return useContext(MailkickSubscriptionIndexContext);
}

const MailkickSubscriptionIndexProvider = (props) => {
  const {
    csrfToken,
    team,
    fan,
    mailkickSubscriptionsByVenueOwnership,
    venueOwnerships,
  } = props;

  const toggleSubscription = (list, subscribed) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    const action = subscribed ? "unsubscribe_from_list" : "subscribe_to_list";

    return axios.put(`/teams/${team.id}/fans/${fan.id}/${action}`, { list });
  };

  const value = {
    csrfToken,
    team,
    fan,
    mailkickSubscriptionsByVenueOwnership,
    venueOwnerships,
    toggleSubscription,
  };

  return (
    <MailkickSubscriptionIndexContext.Provider value={value}>
      {props.children}
    </MailkickSubscriptionIndexContext.Provider>
  );
};

const MailkickSubscriptionIndexContainer = (props) => (
  <MailkickSubscriptionIndexProvider {...props}>
    <ToastContainer icon={false} />
    <MailkickSubscriptionIndex />
  </MailkickSubscriptionIndexProvider>
);

export default MailkickSubscriptionIndexContainer;
